import { ContentMetadata } from "generated/CoreApi_v1";
import HtmlUtils from "lib/HtmlUtils";
import LibUtils from "lib/LibUtils";
import { Accept } from "react-dropzone";
import { SessionService } from "services/sessionService";

export default class MediaUtils {

    static DropzoneAcceptImages(): Accept {
        return {
            "images/*": this.AcceptImages()
        };
    }

    static DropzoneAcceptVideos(): Accept {
        return {
            "video/*": this.AcceptVideos()
        };
    }

    static AcceptImages(): string[] {
        return [
            ".png",
            ".jpg",
            ".jpeg",
            ".gif"
        ];
    }

    static AcceptVideos(): string[] {
        return [
            ".3gp",
            ".flv",
            ".wmv",
            ".asf",
            ".avi",
            ".mov",
            ".mkv",
            ".mp4"
        ];
    }

    static AcceptAudios(): string[] {
        return [
            ".mp3",
            ",m4a"
        ];
    }

    static AcceptBrowserVideosOnly(): string[] {
        return [
            ".mp4",
            ".webm",
            ".ogg"
        ];
    }

    static AcceptDocuments(): string[] {
        return [
            ".pdf",
            ".doc",
            ".docx",
            ".xls",
            ".xlsx",
            ".ppt",
            ".pptx",
            ".zip",
            ".txt",
            ".csv"
        ];
    }

    static getFileIcon(fileName: string): string {
        let src = "/img/contenttype/OtherDocument.png";
        if (fileName) {
            if (fileName.indexOf(".pdf") > -1)
                src = "/img/contenttype/Pdf.png";
            else if (fileName.indexOf(".doc") > -1)
                src = "/img/contenttype/Word.png";
            else if (fileName.indexOf(".xls") > -1)
                src = "/img/contenttype/Excel.png";
            else if (fileName.indexOf(".ppt") > -1)
                src = "/img/contenttype/PowerPoint.png";
            else if (fileName.indexOf(".txt") > -1)
                src = "/img/contenttype/Text.png";
            else if (fileName.indexOf(".zip") > -1)
                src = "/img/contenttype/Zip.png";
        }
        return src;
    }

    static isPDF(filename: string): boolean {
        return filename.indexOf(".pdf") > -1;
    }

    static isDocument(filename: string): boolean {
        return filename.indexOf(".doc") > -1;
    }

    static isSheet(filename: string): boolean {
        return filename.indexOf(".xls") > -1;
    }

    static isSlides(filename: string): boolean {
        return filename.indexOf(".ppt") > -1;
    }

    static isPdf(filename: string): boolean {
        return filename.indexOf(".pdf") > -1;
    }

    static isOfficeDocument(filename: string): boolean {
        return MediaUtils.isDocument(filename) || MediaUtils.isSheet(filename) || MediaUtils.isSlides(filename);
    }

    static isImage(mimetype: string): boolean {
        return mimetype.startsWith("image");
    }

    static isVideoOrAudio(mimetype: string): boolean {
        return mimetype.startsWith("audio") || mimetype.startsWith("video");
    }

    static isVideo(mimetype: string): boolean {
        return mimetype.startsWith("video");
    }
    static isAudio(mimetype: string): boolean {
        return mimetype.startsWith("audio");
    }

    static async makeOfficeViewerUrl(url: string) {
        if (HtmlUtils.isLocalhost()) return url;

        const token = await SessionService.getAccessToken();
        if (token != "") {
            url += url.includes("?") ? "&" : "?";
            url += "ptn=" + document.location.hostname;
            url += "&access_token=" + await SessionService.getAccessToken();
            return `https://view.officeapps.live.com/op/view.aspx?src=${url}`;
        }
        return "";
    }

    static async openUrlInNewWindow(filename: string, url: string, windowName: string) {
        if (this.isOfficeDocument(filename))
            url = await this.makeOfficeViewerUrl(url);

        if (url != "")
            return HtmlUtils.openUrlInNewWindow(url, windowName);

        alert('Não foi possível obter acesso ao arquivo para visualização. Tente novamente.');
        return undefined;
    }

    static async openFileViewerOrDownloadUrl(filename: string, url: string) {
        if (this.isOfficeDocument(filename))
            HtmlUtils.openUrlInNewWindow(await this.makeOfficeViewerUrl(url));
        else if (this.isPdf(filename))
            HtmlUtils.openUrlInNewWindow(url);
        else
            HtmlUtils.downloadUrl(url, filename);
    }

    static buildYoutubeEmbedUrl(externalId: string): string {
        return `https://www.youtube.com/embed/${externalId}`;
    }

    static buildYoutubeEmbedHtml(meta: ContentMetadata, autoPlay: boolean): string {
        return `<iframe
                    src="${this.buildYoutubeEmbedUrl(meta.externalId!)}${autoPlay ? "?autoplay=1&muted=1" : ""}"
                    allow="${autoPlay ? "autoplay" : ""}""
                    width="${meta.width}"
                    height="${meta.height}"
                >
                </iframe>`;
    }

    static validFileInput(filename: string, accept: string | string[]) {
        if (accept == null) return true;

        const compare = typeof accept == "string" ? accept.toLowerCase().split(",") : accept;
        if (compare.length == 0) return true;

        const extension = "." + LibUtils.getFileExtension(filename);
        return compare.findIndex(x => x.startsWith("application") || x == extension) > -1;
    }

    static readFileAsString(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            var reader = new FileReader();
            reader.onload = (event: any) => {
                resolve(event.target.result);
            };
            reader.onerror = (e: any) => {
                reject(e);
            };
            reader.readAsText(file);
        });
    }
}
